import { useMutation } from 'react-query';
import { useAxiosInstance } from '../common';

interface Params {
  fileNodeId: string;
}

const useFileNodeGeolocationUpdate = () => {
  const axios = useAxiosInstance();
  return useMutation(
    async (params: Params) => {
      const response = await axios.post("filenode/" + params.fileNodeId + "/geolocate", null);
      return response.data;
    },
    {
      onSuccess: () => {
        //queryClient.invalidateQueries(['rootStructure'], { refetchInactive: true });
      },
    }
  );
};

export default useFileNodeGeolocationUpdate;
